import api from './api';

export const getConversations = async () => {
  const response = await api.get('/chat/conversations');
  return response.data;
};

export const getMessages = async (userId) => {
  const response = await api.get(`/chat/messages/${userId}`);
  return response.data;
};

export const markMessagesAsRead = async (conversationId) => {
  const response = await api.put('/chat/messages/read', { conversationId });
  return response.data;
};
